// test2428
(2428 && 0);
